import React, { useEffect, useState } from 'react';
import useFetchExecs from '../hooks/useFetchExecs';
import { REQUEST_CUSTOM_EVENTS } from '../requestConstants';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, MenuItem, Select } from '@mui/material';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import { getFullName } from '../../../../utils/utils';
import useAssignRequest from '../hooks/useAssignRequest';
import Swal from 'sweetalert2';
import Spinner from '../../../../components/spinner/spinner';
import PropTypes from 'prop-types';

const AssignExecContent = ({ requestDetails }) => {
    const { execs, loading, error } = useFetchExecs();
    const [selectedExec, setSelectedExec] = useState('');
    const { assignRequest, loading: assigning } = useAssignRequest();

    const handleChange = (event) => {
        setSelectedExec(event.target.value);
    };

    const handleAssign = async () => {
        if (assigning) {
            return;
        }
        const { err } = await assignRequest({ fexecId: selectedExec, reqDetails: requestDetails });
        if (err) {
            console.error('Error assigning request:', error);
            if (error?.cause?.response?.data?.message) {
                Swal.fire('Sorry!', error.cause.response.data.message, 'error');
                return;
            }
            Swal.fire('Something Went Wrong!', '', 'error');
            return;
        }

        Swal.fire('Request assigned successfully!', '', 'success');
        document.dispatchEvent(new CustomEvent(REQUEST_CUSTOM_EVENTS.UPDATE_REQ_DETAILS, { detail: {...requestDetails, status: 'ACCEPTED'} }));
        document.dispatchEvent(new CustomEvent(REQUEST_CUSTOM_EVENTS.CLOSE_ASSIGN_EXEC_DIALOG));
    };
    const execsList = execs.map(exec => <MenuItem key={exec.id} value={exec.id}>{getFullName({...exec.fieldexecutive})}</MenuItem>);
    const execsUi = !loading && !error && (
      <div className="input-wrapper-padding">
        <FormControl fullWidth size='small'>
          <InputLabel id="exec-list">Field Executives</InputLabel>
          <Select
            labelId="exec-list"
            value={selectedExec}
            label="Field Executives"
            onChange={handleChange}
          >
            {execsList}
          </Select>
        </FormControl>
      </div>
    );

    const assignBtn = () => {
      const btnText = assigning ? <>Assigning Request&nbsp;<Spinner /></> : 'Assign';
      return <Button variant="contained" onClick={handleAssign} disabled={assigning}> {btnText} </Button>;
    };
    return (
        <>
            <DialogContent>
                {execsUi}
            </DialogContent>
            <DialogActions style={{ paddingInline: '20px', paddingBottom: '20px' }}>
                {/* <Button variant="contained" onClick={handleAssign} disabled={assigning}> {assignBtnContent()} </Button> */}
                {assignBtn()}
            </DialogActions>
        </>
    );
};

AssignExecContent.propTypes = {
    requestDetails: PropTypes.object.isRequired
};

const AssignExec = () => {
    const [showDialog, setShowDialog] = useState(false);
    const [requestDetails, setRequestDetails] = useState(null);

    const toggleDialog = (toggle) => () => {
      setShowDialog(toggle);
    };

    useEffect(() => {
      const controller = new AbortController();
      const closeExecDialog = () => {
        setShowDialog(false);
      };
      const toggleExecDialog = (e) => {
          const reqDetails = e.detail;
          setRequestDetails(reqDetails);
          setShowDialog(true);
      };
      document.addEventListener(REQUEST_CUSTOM_EVENTS.OPEN_ASSIGN_EXEC_DIALOG, toggleExecDialog, { signal: controller.signal });
      document.addEventListener(REQUEST_CUSTOM_EVENTS.CLOSE_ASSIGN_EXEC_DIALOG, closeExecDialog, { signal: controller.signal });
      return () => {
          controller.abort();
      };
    }, []);

    const execContent = requestDetails && <AssignExecContent  requestDetails={requestDetails} />;
    return (
      <Dialog open={showDialog} maxWidth='xs' fullWidth>
          <DialogTitle sx={{ display: 'flex', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>Assign Field Executive</div>
              <IconButton size='small' onClick={toggleDialog(false)}>
                  <CloseOutlinedIcon />
              </IconButton>
          </DialogTitle>
          {execContent}
      </Dialog>
    );
  };

export default AssignExec;